"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("../utils");
var _processRichText = _interopRequireDefault(require("../utils/process-rich-text"));
var _replacementTokenOnly = _interopRequireDefault(require("../utils/rich-text-factories/replacement-token-only"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var createPill = function createPill(_ref) {
  var _sys$contentType;
  var sys = _ref.sys,
    fields = _ref.fields;
  var contentRaw = (0, _utils.getProp)(fields, 'content');
  var content = contentRaw ? (0, _processRichText["default"])({
    document: contentRaw,
    factories: _replacementTokenOnly["default"]
  }) : null;
  return {
    id: (0, _utils.getProp)(sys, 'id'),
    contentType: (0, _utils.getProp)(sys === null || sys === void 0 ? void 0 : (_sys$contentType = sys.contentType) === null || _sys$contentType === void 0 ? void 0 : _sys$contentType.sys, 'id'),
    site: (0, _utils.getProp)(fields, 'site'),
    content: content,
    textSize: (0, _utils.getProp)(fields, 'textSize'),
    colour: (0, _utils.getProp)(fields, 'colour'),
    backgroundColour: (0, _utils.getProp)(fields, 'backgroundColour'),
    icon: (0, _utils.getProp)(fields, 'icon')
  };
};
var _default = createPill;
exports["default"] = _default;